import "./AppDownloadsElement.less";
import { DownloadsStore } from "./DownloadsStore";
import { VersionNumber } from "./VersionNumber";

export class AppDownloadsElement extends HTMLElement { 
    static tag = "app-downloads";
    private _closeButton: HTMLButtonElement;
    private _downloadsArea: HTMLElement;
    
    async connectedCallback() {         
        this.innerHTML = this.view();

        this._downloadsArea = this.querySelector("[name=downloads]");
        this._closeButton = this.querySelector("[name=minimize]");
        this._closeButton.addEventListener("click", this.onClose);

        const downloads = await DownloadsStore.instance.getDownloads();

        this._downloadsArea.innerHTML = downloads.map(this.downloadView).join("");
    }

    disconnectedCallback() { 
        this._closeButton.removeEventListener("click", this.onClose);
    }
    
    private onClose = () => this.remove();

    private formatDate = (dateString: string) => {
        if (!dateString)
            return "";

        const date = new Date(dateString.indexOf("T") !== -1 ? dateString : `${dateString}Z`);

        // check if date is today
        const today = new Date();
        if (date.getDate() === today.getDate() && date.getMonth() === today.getMonth() && date.getFullYear() === today.getFullYear())
            return `${date.getHours()}:${this.pad(date.getMinutes())}`;

        return `${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()}`;
    }

    private view = () => `
        <button class=icon name=minimize type=button>${require("./Images/close.svg")}</button>
        <header>Downloads</header>
        <div name=downloads>
           Loading ...
        </div>
    
    `;

    private downloadView = (download: Download) => `
        <div class=download>
            <div>
                <div class=version>${download.version} <span>${this.formatDate(download.created)}</spam></div>
                <div class=description>${download.description}</div>
            </div>
            <div class=link>
            <a href="${download.path}" download="${download.path}" class=icon>${require("./Images/downloads.svg")}</a>
            </div>
        </div>
    `

    private pad = (no: number, wantedLength = 2, symbol = "0") => {
        const source = no.toString();
        return source.length >= wantedLength ? source : new Array(wantedLength - source.length + 1).join(symbol) + source;
    }
}

customElements.define(AppDownloadsElement.tag, AppDownloadsElement);

export interface Download { 
    created: string;
    description: string;
    path: string;
    version: string;
    versionNumber: VersionNumber;
}